import axios, { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { showRootPage } from '../services/navigation-service/navigation.service';
import { cleanupToken, getToken } from '../services/token-service/token.service';
import { cleanupUserData } from '../services/user-service/user.service';

const BASE_URL = `${process.env.REACT_APP_API_URL}/`;

type RequestConfigWithFlags = InternalAxiosRequestConfig & {
  headers: InternalAxiosRequestConfig['headers'] & {
    doNotAddUserTokenAuthorization?: boolean;
  };
};

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL
});

const cleanup = () => {
  cleanupToken();
  cleanupUserData();
};

axiosInstance.interceptors.request.use(async (config: RequestConfigWithFlags) => {
  if (!config.headers?.doNotAddUserTokenAuthorization) {
    const token = getToken();
    (config.headers as any).Authorization = `Bearer ${token}`;
  }

  if (config.headers) {
    delete (config.headers as any).doNotAddUserTokenAuthorization;
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const url = error.response?.config?.url;

    if (error.response?.status === 401 && url !== '/auth') {
      cleanup();
      showRootPage();
    }

    return Promise.reject(error.response as AxiosResponse<AxiosError>);
  }
);
